module.exports = "/lucky-balls/img/drum/drum_loop_023.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_023.png
// module id = 1038
// module chunks = 0